import React from "react";
import { URL_CONSTANTS } from "../utils/constants";

import '../css/account-failed.css';
import { useNavigate } from "react-router";

const AccountFailedComponent = () => {
  const navigate = useNavigate();
  const goToSignup  = () => {
    navigate('/');
  }
  return (
    <div class="form-hero-section bg-lblack section-padding account-failed">
      <div class="form-container">
        <div class="form-hero-block">
          <div class="form-hero-content">
            <h2>
              Oops! Something Went Wrong
            </h2>
            <div>
              <p>We couldn’t create your account this time</p>
            </div>
            <div class="site-text">
              <p>But don’t worry—You can try again</p>
            </div>
          </div>
          <div class="form-hero-code">
            <div class="step-form-block">
              <div class="form-response">
                <div class="form-response-image">
                  <img src="https://www.apty.io/wp-content/uploads/2025/01/error.svg" style={{ maxWidth: '100%' }} alt="" />
                  <div class="form-response-text">
                    <div class="fs-24 fw-500">Oops! </div>
                    <div class="color-text">Something went wrong</div>
                  </div>
                </div>
                <div class="form-footer mt-20 text-center">
                  <a class="form-btn" onClick={() => goToSignup()}>Try Again</a>
                  <div class="help-text">Need help? <a href={URL_CONSTANTS.GET_IN_TOUCH} target="_blank" rel="noopener">Get in Touch</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountFailedComponent;
